import { render } from "./UserComponent.vue?vue&type=template&id=73b2e7b5&scoped=true"
import script from "./UserComponent.vue?vue&type=script&lang=js"
export * from "./UserComponent.vue?vue&type=script&lang=js"

import "./UserComponent.vue?vue&type=style&index=0&id=73b2e7b5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b2e7b5"]])

export default __exports__